import { render, staticRenderFns } from "./AxGroupPanel.vue?vue&type=template&id=118f3391"
import script from "./AxGroupPanel.vue?vue&type=script&lang=ts"
export * from "./AxGroupPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports